import React, {Component} from 'react';
import {connect} from 'react-redux'
import {Route, Switch, withRouter, Redirect} from 'react-router-dom';
import './App.css';
import * as actions from './store/actions';
import Login from './containers/Login/Login';
import ForgotPassword from './containers/forgotPassword/ForgotPassword';
import NewPassword from './containers/newPassword/NewPassword';
import AccountSettings from './containers/accountSettings/AccountSettings';
import Dashboard from './containers/dashboard/Dashboard';
import GcpDashboard from './containers/gcpDashboard/Dashboard'
import Installation from './containers/installation/Installation';
import Xogroups from './containers/xogroups/Xogroups';
import Scheduler from './containers/scheduler/Scheduler';
import Budget from './containers/budget/Budget';
import Alerts from './containers/alerts/Alerts';
import SamlRedirect from "./containers/Login/SamlRedirect";
import LoginPw from "./containers/Login/LoginPw";
import SamlLogIn from "./containers/Login/SamlLogIn";

class App extends Component {
    UNSAFE_componentWillMount() {
        let path = this.props.location.pathname;
        if (path === '/dashboard' || path === '/gcpDashboard' || path === '/accountSettings' || path === '/installation' || path === '/xogroups' || path === "/schedulers" || path === "/budgets" || path === "/alerts") {
            this.props.onTryLogin();
        }
    }

    render() {
        let path = this.props.location.pathname
        if (!this.props.isAuthenticated && (path === '/dashboard' || path === '/gcpDashboard' || path === '/accountSettings' || path === '/installation' || path === '/xogroups' || path === '/schedulers' || path === "/budgets" || path === "/alerts") ) {
            return <Redirect to="/"/>
        }
        if (path === "/" && this.props.isAuthenticated) {
            let beforePath = sessionStorage.getItem("beforeRefreshPage")
            if (beforePath !== null) {
                this.props.location.pathname = beforePath
            }
        }
        sessionStorage.setItem("beforeRefreshPage", path)
        return (
            <div>
                <Switch>
                    <Route path="/login" component={Login}/>
                    <Route path="/password" component={LoginPw}/>
                    <Route path="/forgotPassword" component={ForgotPassword}/>
                    <Route path="/updatePassword" component={NewPassword}/>
                    <Route path="/accountSettings" component={AccountSettings}/>
                    <Route path="/dashboard" component={Dashboard}/>
                    <Route path="/gcpDashboard" component={GcpDashboard}/>
                    <Route path="/installation" component={Installation}/>
                    <Route path="/xogroups" component={Xogroups}/>
                    <Route path="/budgets" component={Budget}/>
                    <Route path="/schedulers" component={Scheduler}/>
                    <Route path="/alerts" component={Alerts}/>
                    <Route path="/samlRedirect" component={SamlRedirect}/>
                    <Route path="/samlLogin" component={SamlLogIn}/>
                    <Route path="/" exact component={Login}/>
                    <Redirect to="/"/>
                </Switch>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        isAuthenticated: (state.settings.token !== null) || (state.login.token !== null)
    }
};

const mapDispatchToProps = dispatch => {
    return {
        onTryLogin: () => dispatch(actions.checkLoginState())
    }
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(App));
